import React from "react";
import { Fragment, useState } from "react";
import { VelocityButton } from "./VelocityButton";

const Card = ({
  cardDetails,
  user,
  appLink,
  appUrl,
  extAppLink,
  extAppUrl,
  cardIndex = 0, // Add index prop for consistent color ordering
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  // Function to get card variant based on index for consistent ordering
  const getCardVariant = (index) => {
    const variants = ['blue', 'green', 'purple'];
    return variants[index % 3];
  };

  const variant = getCardVariant(cardIndex);

  // Function to get appropriate icon based on card content
  const getIconForCard = (cardName, description) => {
    const name = cardName.toLowerCase();
    const desc = description.toLowerCase();
    
    // Intellifiber - WiFi/Network icon
    if (name.includes('intellifiber') || name.includes('fiber')) {
      return <path d="M1 9L2 8L11 17L22 6L23 7L11 19L1 9M21 3L22.5 4.5L21 6L19.5 4.5L21 3M17.5 0.5L19 2L17.5 3.5L16 2L17.5 0.5M10 12L8 10L10.5 7.5L12 9L10 12M6.5 3.5L8 5L6.5 6.5L5 5L6.5 3.5M3 0.5L4.5 2L3 3.5L1.5 2L3 0.5Z" />;
    }
    
    // ArcGIS/GIS - Map/Location icon
    if (name.includes('arcgis') || name.includes('gis') || name.includes('map')) {
      return <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z" />;
    }
    
    // Power BI/Analytics - Chart icon
    if (name.includes('power bi') || name.includes('powerbi') || name.includes('analytics') || name.includes('dashboard')) {
      return <path d="M3 3V21H21V19H5V3H3M9 17H7V10H9V17M13 17H11V7H13V17M17 17H15V13H17V17Z" />;
    }
    
    // Billing/Financial - Dollar icon
    if (name.includes('billing') || name.includes('finance') || name.includes('payment') || name.includes('invoice')) {
      return <path d="M7 15H9C9 16.08 10.37 17 12 17S15 16.08 15 15C15 13.9 13.96 13.5 11.76 12.97C9.64 12.44 7 11.78 7 9C7 7.21 8.47 5.69 10.5 5.18V3H13.5V5.18C15.53 5.69 17 7.21 17 9H15C15 7.92 13.63 7 12 7S9 7.92 9 9C9 10.1 10.04 10.5 12.24 11.03C14.36 11.56 17 12.22 17 15C17 16.79 15.53 18.31 13.5 18.82V21H10.5V18.82C8.47 18.31 7 16.79 7 15Z" />;
    }
    
    // Portal/Management - Settings icon
    if (name.includes('portal') || name.includes('admin') || name.includes('manage')) {
      return <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5A3.5 3.5 0 0 1 15.5 12A3.5 3.5 0 0 1 12 15.5M19.43 12.98C19.47 12.66 19.5 12.33 19.5 12S19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.96 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.13 5.07C8.52 5.32 7.96 5.66 7.44 6.05L4.95 5.05C4.73 4.96 4.46 5.05 4.34 5.27L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11.02C4.53 11.34 4.5 11.67 4.5 12S4.53 12.66 4.57 12.98L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.94C7.96 18.34 8.52 18.68 9.13 18.93L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.94L19.05 18.95C19.27 19.03 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98Z" />;
    }
    
    // Database/Data - Database icon
    if (name.includes('database') || name.includes('data') || name.includes('sql')) {
      return <path d="M12 3C7.58 3 4 4.79 4 7S7.58 11 12 11 20 9.21 20 7 16.42 3 12 3M4 9V12C4 14.21 7.58 16 12 16S20 14.21 20 12V9C20 11.21 16.42 13 12 13S4 11.21 4 9M4 14V17C4 19.21 7.58 21 12 21S20 19.21 20 17V14C20 16.21 16.42 18 12 18S4 16.21 4 14Z" />;
    }
    
    // Network/Infrastructure - Network icon
    if (name.includes('network') || name.includes('infrastructure') || name.includes('broadband')) {
      return <path d="M4 1C2.89 1 2 1.89 2 3V7C2 8.11 2.89 9 4 9H1V11H13V9H10C11.11 9 12 8.11 12 7V3C12 1.89 11.11 1 10 1H4M4 3H10V7H4V3M3 13V18L1 20H23L21 18V13H3M5 15H19V17H5V15Z" />;
    }
    
    // Communication/Support - Support icon
    if (name.includes('support') || name.includes('help') || name.includes('chat')) {
      return <path d="M12 3C6.5 3 2 6.58 2 11C2.05 13.15 3.06 15.17 4.75 16.5C4.75 17.1 4.33 18.67 2 21C4.37 20.89 6.64 20 8.47 18.5C9.61 18.83 10.81 19 12 19C17.5 19 22 15.42 22 11S17.5 3 12 3Z" />;
    }
    
    // Cloud/Server - Cloud icon
    if (name.includes('cloud') || name.includes('server') || name.includes('hosting')) {
      return <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15S21.76 10 19 10L19.35 10.04Z" />;
    }
    
    // Security - Shield icon
    if (name.includes('security') || name.includes('secure') || name.includes('auth')) {
      return <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M12 7C13.4 7 14.8 8.6 14.8 10V11C15.4 11 16 11.4 16 12V16C16 16.6 15.6 17 15 17H9C8.4 17 8 16.6 8 16V12C8 11.4 8.4 11 9 11V10C9 8.6 10.6 7 12 7M12 8.2C11.2 8.2 10.2 9.2 10.2 10V11H13.8V10C13.8 9.2 12.8 8.2 12 8.2Z" />;
    }
    
    // Default - Application icon
    return <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M17 12H15V17H17V12M13 7H11V17H13V7M9 10H7V17H9V10Z" />;
  };

  // Icon component based on variant
  const CardIcon = () => {
    const iconClass = `appCard__icon appCard__icon--${variant}`;
    
    return (
      <div className={iconClass}>
        <svg viewBox="0 0 24 24" fill="currentColor">
          {getIconForCard(cardDetails.name, cardDetails.description)}
        </svg>
      </div>
    );
  };

  // Handle card click for view details
  const handleCardClick = (e) => {
    // Don't trigger if clicking on a button
    if (e.target.closest('button') || e.target.closest('a')) {
      return;
    }
    
    // For cards with launch buttons, still open view details on card click
    if (appUrl) {
      window.open(appUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Fragment>
      <div 
        className={`appCard appCard--${variant} ${!appLink ? 'appCard__disabled' : ''}`}
        onClick={handleCardClick}
      >
        <div className="appCard__content">
          <div className="appCard__top">
            <CardIcon />
            
            <div className="appCard__heading">
              {cardDetails.name}
            </div>
            
            <div className="appCard__description">
              {cardDetails.description}
            </div>
          </div>
          
          {/* Footer with Launch App button - always visible */}
          <div className="appCard__footer">
            {appLink ? (
              cardDetails?.appId === "3217810" || cardDetails?.appId === "3217960" || cardDetails?.appId === "4395474" ? (
                extAppUrl && (
                  <VelocityButton
                    variant="primary"
                    href={extAppUrl}
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                    className={`card-btn--${variant}`}
                  >
                    Launch App
                  </VelocityButton>
                )
              ) : (
                <VelocityButton
                  variant="primary"
                  href={appUrl}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                  className={`card-btn--${variant}`}
                >
                  Launch App
                </VelocityButton>
              )
            ) : (
              <div 
                className="appCard__button-wrapper"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <VelocityButton
                  variant="primary"
                  disabled
                  className={`card-btn--${variant}`}
                >
                  Launch App
                </VelocityButton>
                {showTooltip && (
                  <div className="appCard__tooltip">
                    {user && cardDetails.name === "NOC X" 
                      ? "You don't have permission to access this app" 
                      : "Please login to launch app"}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Card;
